<template>
    <div class="FloorEquipmentElectricity" >
        <Title firstName="暖通设备信息" lastName="POWER CONSUMPTION OF EQUIPMENT"/>
        <div class="echarts">
            <div class="over">
                研发大楼
                <!-- <div class="selectMonitor" @click="tagishow=!tagishow">
                    <div class="tagname">{{tagname}}
                        <i class="el-icon-caret-bottom"></i></div>
                    <div class="list" v-if="tagishow">
                        <SelectList :selectList="tagList" @tabTitle="tabTitletag" keyk="id" keyval="name"/>
                    </div>
                </div> -->
            </div>
          <div class="tags">
              <div class="btn" :class="{active:active==0}" @click="active=0">VRV空调</div>
              <div class="btn" :class="{active:active==1}" @click="active=1">新风换气机</div>
              <div class="btn" :class="{active:active==2}" @click="active=2">送排风机</div>
          </div>
          <div class="mark">
              <span><img src="../../../../assets/img/floor3.png">开启</span>
              <span><img src="../../../../assets/img/floor4.png">关闭</span>
              <span v-if="active==2"><img src="../../../../assets/img/floor5.png">故障</span>
          </div>
          <div class="floor" v-if="active!=2">
              <span  v-for="item in reverseSum" :class="{active:true}" :key="item">{{item}}F</span>
          </div>
          <div class="line" v-else>
              <div class="pre"><img src="../../../../assets/img/pre.png" alt=""></div>
              <div class="next"><img src="../../../../assets/img/next.png" alt=""></div>
              <span>D1_WVP1# 排烟机</span>
              <span>D1_WVP1# 排烟机</span>
              <span>D1_WVP1# 排烟机</span>
              <span>D1_WVP1# 排烟机</span>
          </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
const SelectList = () => import('../../../../components/title/selectList.vue')
export default {
    
    data(){
        return {
            tagname:"切换楼栋",
            tagishow:false,
            tagList:[
                {
                    id:1,
                    name:'日'
                },
                {
                    id:2,
                    name:'月'
                },
            ],
            active:0,
            allSum:[1,2,3,4,5,6,7,8,9,10,11]
        }
    },
    components:{
        Title,Graph,charts,SelectList
    },
    
    computed:{
        reverseSum() {
            return this.allSum.reverse();
        },
        routeName() {
            return this.$route.query.name;
        },
    },
    mounted(){
    },
    methods:{
        tabTitletag(item){
            this.tagname = item.name
        },
        
    },
}
</script>

<style lang="less" scoped>
    .FloorEquipmentElectricity{
        width: 20vw;
        position: fixed;
        // top: 31.4vh;
        top: 53.5vh;
        left: 2vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 39.5vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            overflow: hidden;
            color: rgba(230, 243, 253, 0.7);
            .tags{
                text-align: center;
                overflow: hidden;
                width: 100%;
                .btn{
                    background: url('../../../../assets/img/btn3.png') no-repeat center;
                    
                    text-align: center;
                    height: 34rem;
                    line-height: 34rem;
                    font-size: 14rem;
                    margin: 3rem 5rem;
                    width: 5.5vw;
                    cursor: pointer;
                    display: inline-block;
                }
                .active{
                    background: url('../../../../assets/img/floor7.png') no-repeat center;
                }
            }
            .line{
                text-align: center;
                position: relative;
                .pre{
                    position: absolute;
                    top: 40%;
                    left: 8%;
                }
                .next{
                    position: absolute;
                    top: 40%;
                    right: 8%;
                }
                span{
                    display: inline-block;
                    width: 280rem;
                    height: 4.5vh;
                    text-align: center;
                    line-height: 4.5vh;
                    font-family: zcoolqingkehuangyouti;
                    font-size: 24rem;
                    margin: 5rem 9rem;
                    background: url('../../../../assets/img/floor6.png') no-repeat center;
                    background-size: 100% 100%;
                    cursor: pointer;
                }
            }
            .mark{
                text-align: right;
                padding: 10rem 20rem;
                span{
                    margin-left: 20rem;
                    img{
                        margin-right: 5rem;
                        vertical-align: middle;
                    }
                }
            }
            .floor{
                overflow: hidden;
                padding: 0 10rem;
                width: 105%;
                span{
                    display: inline-block;
                    width: 3.1vw;
                    height: 5.5vh;
                    text-align: center;
                    line-height: 5.5vh;
                    font-family: zcoolqingkehuangyouti;
                    font-size: 24rem;
                    margin: 0.8vh 0.38vw;
                    background: url('../../../../assets/img/floor2.png') no-repeat center;
                    background-size: 100% 100%;
                    cursor: pointer;
                }
                .active{
                    background: url('../../../../assets/img/floor.png') no-repeat center;
                    background-size: 100% 100%;
                }
            }
            .over{
                display: block;
                padding: 10rem 20rem;
                
            }
            .selectMonitor{
                text-align: right;
                margin-right:10rem;
                color: #E6F3FD ;
                cursor: pointer;
                position: relative;
                z-index: 99;
                display:inline-block;
                float: right;
                .tagname{
                    border: 1px solid rgba(255, 255, 255, 0.5);
                    border-radius: 2rem;
                    display: inline-block;
                    width: 100rem;
                    text-align: center;
                }
                .list{
                    position: absolute;
                    right: 0;
                    width: 100%;
                    top: 100%;
                    text-align: left;
                }
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
</style>